import React from 'react';
import i18next from 'i18next';
import {
  THeader,
  TTableBody,
  TTableRow
} from '../../shared_components/vrr_table/types';
import { TAccountRow, TAccountsAPI } from './types';

export const prepareHeader = (): THeader['element'][] => {
  return [
    {
      id: 'vrr_id',
      component: (
        <p>
          {i18next
            .t('connected_account.accounts_table.header.vrr_id')
            .toUpperCase()}
        </p>
      )
    },
    {
      id: 'name',
      component: (
        <p>
          {i18next
            .t('connected_account.accounts_table.header.name')
            .toUpperCase()}
        </p>
      )
    }
  ];
};

export const prepareLine = (account: {
  vrr_id: string;
  name: string;
}): TAccountRow[] => {
  const header = prepareHeader();
  return Object.values(account)?.map((cell, index) => ({
    headerId: header[index].id,
    rowId: account.vrr_id.toString(),
    value: cell
  }));
};

const getLine = (line: TAccountRow[]): TTableRow['cellElements'] => {
  return line?.map((cell) => {
    return {
      headerId: cell.headerId,
      id: cell.rowId,
      component: (
        <label className="account-value" htmlFor={`accounts-${line[0].rowId}`}>
          <span>{cell.value}</span>
        </label>
      ),
      value: cell.value
    };
  });
};

export const prepareBody = (
  accounts?: TAccountsAPI[]
): TTableBody['rowElements'] => {
  const newBody: TTableBody['rowElements'] = [];
  accounts?.forEach((account) => {
    if (account.role !== 'available') {
      const line = prepareLine({
        vrr_id: account.vrr_id.toString(),
        name: account.name
      });
      newBody.push(getLine(line));
    }
  });

  return newBody;
};
